import styled from 'styled-components';

import { MOBILE } from '../../theme/tokens';

/** Full-bleed content column under the Website tabs: the logo set spans the whole content area, as it did
 *  on the Website Settings page it moved from. */
export const Page = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${MOBILE} {
    gap: 14px;
  }
`;
